import React from "react";
import PropTypes from "prop-types";
import { Wrapper, Inner, Text, Check } from "./styles/modal-thank-you-styles";
import check from "./img/check.gif";

const ModalThankYou = (props) => {
  const { text } = props;

  return (
    <Wrapper>
      <Inner>
        <Check src={check} alt="Thank You Check" className="animated fadeIn" />
        <Text className="animated delay fadeInDown">{text}</Text>
      </Inner>
    </Wrapper>
  );
};

ModalThankYou.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ModalThankYou;
